if(window.jQuery)  init();
else{
    var script = document.createElement('script');
    document.head.appendChild(script);
    script.type = 'text/javascript';
    script.src = "https://code.jquery.com/jquery-3.2.1.js";
    script.onload = init;
}

function init(){
    if (typeof Shopify.getCart === "undefined" || typeof Shopify.getCart === undefined) {
        Shopify.getCart = function (t) {
            jQuery.getJSON("/cart.js", function (r) {
                if ("function" == typeof t)
                    t(r);
            })
        };
    }

    if (typeof Shopify.clear === "undefined" || typeof Shopify.clear === undefined) {
        Shopify.clear = function (t) {
            var r = {
                type: "POST",
                url: "/cart/clear.js",
                data: "",
                dataType: "json",
                success: function (r) {
                    t(r);
                },
                error: function (t, r) {
                    Shopify.onError(t, r);
                }
            };
            jQuery.ajax(r);
        };
    }

    (function($){

        $(function () {

            if(window.location.href.indexOf("pages/cml_checkout") > -1) {
                Shopify.getCart(function (data) {
                    if (!data.items.length) {
                        alert("There are no items in the cart. Redirecting to home page.");
                        window.location = "/";
                    }
                });
            }

            if (!$.fn.on) {
                $.fn.on = function (events, selector, callback) {
                    $(document).delegate(selector, events, callback);
                }
            }

            function createOrder(customerId, address, $submit, cartData, customer_email) {

                var $self = $(this);

                if ( $self.data('requestRunning') ) {
                    return;
                }

                $self.data('requestRunning', true);

                var shippingAddress = {};
                var valid = true;
                var attributes = {};
                //var attributes = {purchase_number: $("#purchase_number").val()};
                if ($('.submit-address').length) {
                    $('.submit-address').find('[name^="address"]').each(function () {

                        shippingAddress[this.name.replace('address[', '').replace(']', '')] = this.value;

                    });
                }

                shippingAddress['shipping_charges'] = $('.submit-address').find('[name="address[shipping_charges]"]:checked').val();

                cartData.discount = '';
                if ($('#discount').val()) {
                    cartData.discount = $('#discount').val();
                }

                cartData.note = '';
                if ($('#note').val()) {
                    cartData.note = $('#note').val();
                }

                var customer_email = $("input[name=email]").val();

                $.ajax("/apps/create-cml-order", {
                    type: "post",
                    dataType: "json",
                    crossDomain: true,
                    data: {
                        customer: customerId,
                        address: address,
                        cart: cartData,
                        shipping_address: shippingAddress,
                        attributes: attributes,
                        customer_email: customer_email
                    },
                    success: function (data) {
                        if (data.success) {
                            Shopify.clear(function () {
                                show_popup();
                                //window.location.href = "/pages/"+storeArguments.handle+"-thankyou";
                            });
                        } else {
                            alert(data.error);
                        }
                    },
                    error: function () {
                        alert("An error occurred creating the order, please try again.");
                    },
                    complete: function (){
                        hide_loader();

                        $self.data('requestRunning', false);

                    }
                });

            }


            function handleCheckout(e) {

                e.preventDefault();

                if(storeArguments.instantPayment){

                    pay_instant();

                }else{

                    var $self = $(this);

                    var checkout_page = "/pages/cml_checkout";

                    show_loader();

                    if ( $self.data('requestRunning') ) {
                        return;
                    }

                    $self.data('requestRunning', true);

                    Shopify.getCart(function (data) {
                        if (!data.items.length) {
                            alert("There are no items in the cart");
                        } else {

                            // temp fix until we know everyone has installed the new confirmation page
                            $.ajax({
                                type: 'HEAD',
                                url: checkout_page,
                                success: function () {
                                    if ($self.hasClass('checkout-skipper')) {
                                        if ($('[name="note"]').length)
                                            data['note'] = $('[name="note"]').val();
                                        createOrder(storeArguments.customer, storeArguments.shopAddress, $self, data, storeArguments.customer_email);
                                    } else {
                                        window.location.href = checkout_page;
                                    }
                                },
                                error: function () {
                                    // page does not exist
                                    if ($('[name="note"]').length)
                                        data['note'] = $('[name="note"]').val();
                                    createOrder(storeArguments.customer, storeArguments.shopAddress, $self, data, storeArguments.customer_email);
                                },
                                complete: function(){
                                    $self.data('requestRunning', false);
                                }
                            });
                        }
                    });
                }
            }

            $(document).on("click", "#checkout_place_order", handleCheckout);

            $('[onclick="window.location=\'/checkout\'"]').each(function () {
                $(this).removeAttr('onclick');
                $(this).click(handleCheckout);
            });

            // when the cart action is /cart we need to handle submit buttons with the name "checkout"
            $(document).on('click', 'form[action="/cart"] [type="submit"][name="checkout"], form[action="/cart"] [type="image"], form#cartform [type="image"], form#cartform [type="submit"]', function (e) {
                handleCheckout(e);
            });

            $(document).on('submit', 'form[action="/cart"] [name="checkout"], form[action="/checkout"], form#cartform', function (e) {
                handleCheckout(e);
            });

            // prevent trade order customers from being redirected to checkout after logging in
              if (document.referrer != "https://hobowholesale.com/pages/a-note-to-our-partners") {
              // $('#customer_login input[name="checkout_url"]').remove();
            }
            // remove any checkout with paypal buttons if trade orders is active
            $('.additional-checkout-buttons, .additional_checkout_buttons').remove();


            /* draft orders table start */
            if($("#CML_draft_orders").length > 0){
                // call to show the draft orders
                get_draft_orders();
            }

            // setup draft orders table pagination
            $(document).on("click", ".cml_pagination span", function(){

                // call to show the draft orders
                get_draft_orders($(this).data("cursor"), $(this).attr('class'));

            })
            /* draft orders table end */

        });
    }(jQuery));
    function show_popup() {
        // Initialize Variables
        var overlay = document.getElementById("overlay");
        var popup = document.getElementById("popup");
        overlay.style.display = 'block';
        popup.style.display = 'block';
    }



    function show_loader(){
        $(".loader").show();
        $("#checkout_place_order").hide();
    }
    function hide_loader(){
        $(".loader").hide();
        $("#checkout_place_order").show();
    }

}

function hide_popup() {
    // Initialize Variables
    var overlay = document.getElementById("overlay");
    var popup = document.getElementById("popup");
    overlay.style.display = 'none';
    popup.style.display = 'none';
    // similar behavior as clicking on a link
    window.location.href = '/';
}

function pay_instant() {

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {

            var http = new XMLHttpRequest();
            var url = '/apps/create-cml-order';
            var params = 'address='+ storeArguments.shopAddress +'&customer=' + storeArguments.customer + '&cart=' + this.responseText;
            http.open('POST', url, true);

            //Send the proper header information along with the request
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            http.onreadystatechange = function() {//Call a function when the state changes.
                if(this.readyState == 4 && this.status == 200) {

                    var data = $.parseJSON(this.responseText);

                    console.log(data);

                    if(data.success){


                        window.location = data.success.invoice_url;
                        console.log(data.success.invoice_url);

                    }
                }
            }
            http.send(params);

        }
    };
    xhttp.open("GET", "/cart.js", true);
    xhttp.send();
}

function get_draft_orders(cursor, action){
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {

            var http = new XMLHttpRequest();
            var url = '/apps/create-cml-order';
            var params = 'address='+ storeArguments.shopAddress +'&customer=' + storeArguments.customer + '&action=draft_order_list' + "&cursor="+ cursor + "&pagination_action=" + action;
            http.open('POST', url, true);

            //Send the proper header information along with the request
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            http.onreadystatechange = function() {//Call a function when the state changes.
                if(this.readyState == 4 && this.status == 200) {

                    document.getElementById('CML_draft_orders').innerHTML = this.responseText;
                }
            }
            http.send(params);

        }
    };
    xhttp.open("GET", "/cart.js", true);
    xhttp.send();
}

function get_shipping() {
      
        var shippingAddress = { 
          country:$('#AddressCountry').val(), 
          province:$('#AddressProvince').val(), 
          zip : $('#zipCode').val(),
          f_name:$("input[name='address[first_name]']").val(),
          l_name:$("input[name='address[last_name]']").val(),
          address:$("input[name='address[address1]']").val(),
          city:$("input[name='address[city]']").val(),
          phone:$("input[name='address[phone]']").val()
        };
      
        var customer_email = $("input[name=email]").val();
  
        // var phone_no = $("input[name='address[phone]']").val();
        
        Shopify.getCart(function (cartData) {
          $.ajax("/apps/create-cml-order", {
              type: "post",
              dataType: "json",
              crossDomain: true,
              data: {
                  action: "get_shipping",
                  target: "shipping",
                  cart: cartData,
                  shipping_address: shippingAddress,
                  customer_email: customer_email,
                  // phone: phone_no
              },
              success: function (data) {
      
                // show tax
                if (data.totalTax) {
                    total_tax = data.totalTax.presentmentMoney.amount;
                    $(".tax").show().find(".price").html(data.totalTax.presentmentMoney.amount);
                }
                
                console.log(data);

                if (data.shipping) {
      
                      var shippings = data.shipping;
                      var html = "";
                    
                      for(let i=0; i<shippings.length; i++){
      
                        var s_title = shippings[i].title;
      
                        var s_price = shippings[i].price.amount;
                        
                        // prepare HTML for shipping
                        html += "<div class='shipping-row'><div class='select-wrapper'>";
                        html += "<input type='radio' name='address[shipping_charges]' value='"+ [s_title, s_price] +"'>";
                        html += "<span>" + s_title + "</span></div>";
                        html += "<span class='price-row'>" + s_price + "</span></div>";
        
                      }
        
                      $(".shipping_container").html(html);
        
                      // auto select the first option
                      $(".shipping_container input:first").attr('checked', true).change();
                      $(".shipping").show();
        
                      // hide continue button now
                      $("#place_order").hide();
                }
              },
              error: function () {
                  alert("An error occurred creating the order, please try again.");
              },
              complete: function (){
                $(".shipping_charges").hide();
              },
              beforeSend: function(){
                $(".shipping_charges").show();
              },
          });
        });
        
    }

    function fetchShippingRates(shippingAddress) {

        // UI reset
        $('#checkout_place_order').hide();
        $(".shipping_charges").show();
        $(".shipping_container").html('');
        $(".error").hide().html('');

        var url = "/cart/shipping_rates.json?" + $.param({
            "shipping_address[country]": shippingAddress.country,
            "shipping_address[province]": shippingAddress.province,
            "shipping_address[zip]": shippingAddress.zip
        });

        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",

            success: function (result) {

            if (!result.shipping_rates || result.shipping_rates.length === 0) {
                alert("No shipping found");
                return;
            }

            var html = '';

            result.shipping_rates.forEach(function (rate) {
                html += `
                <div class="shipping-row">
                    <div class="select-wrapper">
                    <input type="radio"
                            name="address[shipping_charges]"
                            value="${rate.name.replace(/,/g, '')},${rate.price}">
                    <span>${rate.name}</span>
                    </div>
                    <span class="price-row">${rate.price}</span>
                </div>
                `;
            });

            $(".shipping_container").html(html);

            // Auto-select first shipping option
            $(".shipping_container input:first").prop('checked', true).change();
            $(".shipping").show();
            $("#place_order").hide();
            },

            error: function (xhr) {

            $(".shipping_container").html('');
            $(".shipping_charges").hide();
            $(".error").hide().html('');

            if (!xhr.responseJSON) {
                alert("Something went wrong while fetching shipping rates.");
                return;
            }

            var res = xhr.responseJSON;
            var messages = [];

            // Cart does not require shipping
            if (res.error === "This cart does not require shipping") {
                show_order_button();
                return;
            }

            // Standard Shopify validation errors
            if (res.shipping_address) {
                Object.values(res.shipping_address).forEach(function (arr) {
                arr.forEach(function (msg) {
                    messages.push(msg);
                });
                });

                alert(messages.join("\n"));
                return;
            }

            // Top-level field errors (zip, country, province, etc.)
            Object.keys(res).forEach(function (key) {
                if (Array.isArray(res[key])) {
                res[key].forEach(function (msg) {
                    messages.push(msg);
                });
                }
            });

            if (messages.length) {
                alert(messages.join("\n"));
                return;
            }

            // Fallback message
            if (res.message) {
                alert(res.message);
                return;
            }

            alert("Unable to fetch shipping rates.");
            },

            complete: function () {
            $(".shipping_charges").hide();
            }
        });
    }